import React, { useState } from "react";
import { Box, Button, Dialog, TextField } from "@mui/material";
import { DialogContent, Stack, Typography, Grid } from "@mui/material";
import { Toast } from "../../components/components/Toast";
import CustomInput from "../../components/components/CustomInput";
import Repo from "../../Repository/Repo";
import ClipLoader from "react-spinners/ClipLoader";
import { CashBox } from "../bank/styles";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import S3FileUpload from "react-s3/lib/ReactS3";
import Config from "../../utils/Config";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

function AddProperty({ onClose, onSuccess, onUpdate, row }) {
  const [loading, setLoading] = useState(false);
  const [newImages, setNewImages] = useState([]);
  const [state, setState] = useState({
    id: row ? row.id : "",
    sellerName: row ? row.sellerName : "",
    purchaserName: row ? row.purchaserName : "",
    detailRegistry: row ? row.detailRegistry : "",
    mutationNo: row ? row.mutationNo : "",
    documentNo: row ? row.documentNo : "",
    totalAmount: row ? row.totalAmount : "",
    received: row ? row.received : "",
    balance: row ? row.balance : "",
    status: row ? row.status : "",
    pics: row ? row.pics : [],
  });

  const handleInput = (e) => {
    const { name } = e.target;
    if (name == "pics") {
      const files = e.target.files;
      setNewImages((prev) => [...prev, ...files]);
    } else {
      const { value } = e.target;
      setState((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleClear = (arg) => {
    setState((prev) => ({ ...prev, [arg]: "" }));
  };

  const toggle = () => {
    if (!loading) {
      onClose();
    }
  };

  const uploadImage = async (item) => {
    try {
      let { location } = await S3FileUpload.uploadFile(item, Config());
      return location;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const handleSubmit = async () => {
    try {
      if (!state.id) {
        Toast("info", "Enter ID");
        return;
      }
      if (!state.sellerName) {
        Toast("info", "Enter seller name");
        return;
      }
      if (!state.purchaserName) {
        Toast("info", "Enter purchaser name");
        return;
      }
      // if (!state.documentNo) {
      //   Toast("info", "Enter document number");
      //   return;
      // }
      setLoading(true);
      let newPics = [];
      if (newImages.length > 0) {
        const apiPromises = newImages.map(uploadImage);
        newPics = await Promise.all(apiPromises);
      }

      if (row) {
        let record = {
          ...row,
          company_code: localStorage.getItem("companyCode"),
        };
        let { data } = await Repo.property({
          request: {
            method: "updateAgreement",
            data: { ...record, ...state, pics: [...state.pics, ...newPics] },
          },
        });
        setLoading(false);
        if (data.response.status.statusCode == 200) {
          Toast("success", "Property Updated");
          onUpdate({ ...record, ...state, pics: [...state.pics, ...newPics] });
        } else {
          Toast("error", data.response.status.statusMessage);
        }
      } else {
        let { data } = await Repo.property({
          request: {
            method: "savePropertyAgreement",
            data: {
              company_code: localStorage.getItem("companyCode"),
              ...state,
              pics: newPics,
            },
          },
        });
        setLoading(false);
        if (data.response.status.statusCode == 200) {
          Toast("success", "Property added");
          onSuccess({
            ...state,
            _id: data.response.data.agreementId,
          });
        } else {
          Toast("error", data.response.status.statusMessage);
        }
      }
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };

  const handleRemoveImg = (arg, idx) => {
    let filtered = state.pics.filter((item) => item != arg);
    setState((prev) => ({ ...prev, pics: filtered }));
  };

  return (
    <Dialog open={true} onClose={toggle} fullWidth maxWidth="sm">
      <CashBox sx={{ p: "16px" }}>
        <Typography sx={{ color: "#4eaf51" }}>
          {row ? "Update property details" : "Add new property details"}
        </Typography>
        <AddCircleOutlineIcon
          onClick={toggle}
          sx={{ color: "#767676", cursor: "pointer" }}
        />
      </CashBox>
      <DialogContent dividers>
        <Grid container spacing="24px">
          <Grid item xs={12}>
            <CustomInput
              name="sellerName"
              label="Name of Seller"
              value={state.sellerName}
              onChange={handleInput}
              onClear={() => handleClear("sellerName")}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomInput
              name="purchaserName"
              label="Name of Purchaser"
              value={state.purchaserName}
              onChange={handleInput}
              onClear={() => handleClear("purchaserName")}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <CustomInput
              name="id"
              label="ID #"
              value={state.id}
              onChange={handleInput}
              onClear={() => handleClear("id")}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <CustomInput
              name="mutationNo"
              label="Mutation No #"
              value={state.mutationNo}
              onChange={handleInput}
              onClear={() => handleClear("mutationNo")}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <CustomInput
              name="documentNo"
              label="Document No #"
              value={state.documentNo}
              onChange={handleInput}
              onClear={() => handleClear("documentNo")}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <CustomInput
              type="number"
              name="received"
              label="Total Received"
              value={state.received}
              onChange={handleInput}
              onClear={() => handleClear("received")}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <CustomInput
              type="number"
              name="totalAmount"
              label="Total Amount"
              value={state.totalAmount}
              onChange={handleInput}
              onClear={() => handleClear("totalAmount")}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <CustomInput
              type="number"
              name="balance"
              label="Balance Amount"
              value={state.balance}
              onChange={handleInput}
              onClear={() => handleClear("balance")}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomInput
              name="detailRegistry"
              label="Detail Registry"
              value={state.detailRegistry}
              onChange={handleInput}
              onClear={() => handleClear("detailRegistry")}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <CustomInput
              name="status"
              label="Status"
              value={state.status}
              onChange={handleInput}
              onClear={() => handleClear("status")}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <TextField
              size="small"
              name="pics"
              //   label="Attach Pics"
              InputLabelProps={{ shrink: true }}
              inputProps={{ multiple: true }}
              //   variant="outlined"
              type="file"
              //   value={state.pics}
              onChange={handleInput}
            />
          </Grid>
          {row && row.pics.length > 0 && (
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Box>
                <Typography sx={{ textAlign: "center" }}>
                  Uploaded Images
                </Typography>
                <Stack direction="row" spacing="8px" flexWrap="wrap">
                  {state.pics.map((img, i) => {
                    return (
                      <Box key={i} className="uploaded-pic">
                        <img height="80px" src={img} alt="" />
                        <Box className="uploaded-pic-delete">
                          <DeleteForeverIcon
                            sx={{
                              color: "red",
                              cursor: "pointer",
                            }}
                            onClick={() => handleRemoveImg(img, i)}
                          />
                        </Box>
                      </Box>
                    );
                  })}
                </Stack>
              </Box>
            </Grid>
          )}
          <Grid item xs={12}>
            {loading && (
              <Stack alignItems="center" width="100%" justifyContent="center">
                <ClipLoader size={33} loading={true} color="#4eaf51" />
              </Stack>
            )}
            {!loading && (
              <Button
                fullWidth
                variant="contained"
                sx={{ textTransform: "none" }}
                onClick={handleSubmit}
              >
                <CheckCircleIcon sx={{ mr: "24px", color: "#fff" }} />
                {row ? "Update Details" : "Save Details"}
              </Button>
            )}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}

export default AddProperty;
